/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

import { boxToQueryBounds, normalizeLng } from '@zcode/nr-utils'
import type { BoxTuple } from '@zcode/state-type'
import type { MaybeCoords } from './getDistanceFromCenter'

const withinBox = (
  { lat, lng }: MaybeCoords,
  box?: BoxTuple | { minLat: number; maxLat: number; minLng: number; maxLng: number }
) => {
  if (!box) {
    return undefined
  }
  if ('length' in box) {
    box = boxToQueryBounds(box)
  }

  const { maxLat, maxLng, minLat, minLng } = box

  const betweenLat = lat != null && lat <= maxLat && lat >= minLat
  let betweenLng
  let normalLng = normalizeLng(lng)

  // crosses international date line
  if (minLng > maxLng) {
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    normalLng = normalLng != null && normalLng > 0 ? normalLng - 180 : normalLng + 180
    betweenLng = normalLng <= normalizeLng(maxLng) + 180 && normalLng >= normalizeLng(minLng) - 180
  } else {
    // @ts-expect-error
    betweenLng = normalLng <= normalizeLng(maxLng) && normalLng >= normalizeLng(minLng)
  }

  return betweenLat && betweenLng
}

export default withinBox
